import { Button, Group, Tooltip } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useState } from 'react';

import { Declaration, DeclarationCustomsType } from '@e-origin/shared';

import { TextInput } from '@components';
import { useGenerateBatchByLrn } from '@hooks/declaration';
import { canBeAmended } from '../helpers';

interface DeclarationDuplicateAndAmendmentProps {
  declaration: Declaration;
  isRfiAmendment?: boolean;
}

export const DeclarationDuplicationAndAmendment: React.FC<DeclarationDuplicateAndAmendmentProps> = ({ declaration, isRfiAmendment = false }) => {
  const isPLDA = declaration.customsState?.sentTo === DeclarationCustomsType.PLDA;
  const regularizationText = isPLDA ? 'Regularization' : 'Amendment';
  let batchNamePrefix = 'DUPL';
  if (canBeAmended(declaration) || isRfiAmendment) {
    batchNamePrefix = isPLDA ? 'REGUL' : 'AMEND';
  }

  const [batchName, setBatchName] = useState(batchNamePrefix + declaration.consignment.referenceNumberUCR);

  const generateBatchByLRNMutation = useGenerateBatchByLrn();

  const handleAmendment = async () => {
    await generateBatchByLRNMutation.mutateAsync({ lrn: declaration.messageInfo.LRN, batchName, regulate: true });
    modals.closeAll();
  };

  const handleDuplicate = async () => {
    await generateBatchByLRNMutation.mutateAsync({ lrn: declaration.messageInfo.LRN, batchName, regulate: false });
    modals.closeAll();
  };

  return (
    <>
      <TextInput label="Batch name" value={batchName} onChange={(event) => setBatchName(event.target.value)} />
      <Group justify="center" mt="md">
        {!isRfiAmendment && (
          <Tooltip label={isPLDA ? 'Duplicate and Invalidate' : 'Duplicate'}>
            <Button type="button" onClick={handleDuplicate} variant="filled" size="lg" loading={generateBatchByLRNMutation.isPending}>
              Duplicate
            </Button>
          </Tooltip>
        )}
        {(canBeAmended(declaration) || isRfiAmendment) && (
          <Button type="button" onClick={handleAmendment} loading={generateBatchByLRNMutation.isPending} variant="filled" size="lg">
            {regularizationText}
          </Button>
        )}
      </Group>
    </>
  );
};
